import { ToolsTranslations } from '@/lib/translations/types';
import { RoeRoaValues } from './types';

interface Props {
  values: RoeRoaValues;
  onValuesChange: (field: keyof RoeRoaValues, value: number) => void;
  translations: ToolsTranslations['roeRoa'];
}

function formatNumber(value: number): string {
  if (value === null || value === undefined) return '';
  try {
    return value.toLocaleString('sv-SE', { maximumFractionDigits: 2 });
  } catch {
    return String(value);
  }
}

function parseNumber(input: string): number {
  if (!input) return 0;
  const normalized = input.replace(/[^0-9,.-]/g, '').replace(/,/g, '.');
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{translations.netIncome}</label>
        <input
          type="text"
          inputMode="decimal"
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
          value={formatNumber(values.netIncome)}
          onChange={(e) => onValuesChange('netIncome', parseNumber(e.target.value))}
          min={0}
          step="0.01"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{translations.totalAssets}</label>
        <input
          type="text"
          inputMode="decimal"
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
          value={formatNumber(values.totalAssets)}
          onChange={(e) => onValuesChange('totalAssets', parseNumber(e.target.value))}
          min={0}
          step="0.01"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{translations.shareholdersEquity}</label>
        <input
          type="text"
          inputMode="decimal"
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
          value={formatNumber(values.shareholdersEquity)}
          onChange={(e) => onValuesChange('shareholdersEquity', parseNumber(e.target.value))}
          min={0}
          step="0.01"
        />
      </div>
    </div>
  );
}


